import * as Blockly from 'blockly/core'

const SPRITE_OPTIONS = [
  ['kiko', 'kiko'],
  ['apel', 'apel'],
  ['batu', 'batu'],
  ['dinding', 'dinding'],
]

export function registerEventBlocks() {
  Blockly.common.defineBlocksWithJsonArray([
    {
      type: 'event_when_start',
      message0: '🏁 %1',
      args0: [{ type: 'field_label_serializable', name: 'TITLE', text: 'saat mulai' }],
      message1: '%1',
      args1: [{ type: 'input_statement', name: 'DO' }],
      previousStatement: null,
      nextStatement: null,
      colour: 30,
      colourSecondary: 35,
      colourTertiary: 25,
      tooltip: 'Jalankan blok di bawahnya saat game mulai',
      hat: 'cap',
    },
    {
      type: 'event_when_sprite_clicked',
      message0: '👆 %1 %2',
      args0: [
        { type: 'field_label_serializable', name: 'TITLE', text: 'saat Klik' },
        { type: 'field_dropdown', name: 'SPRITE', options: SPRITE_OPTIONS },
      ],
      message1: '%1',
      args1: [{ type: 'input_statement', name: 'DO' }],
      previousStatement: null,
      nextStatement: null,
      colour: 30,
      tooltip: 'Jalankan saat sprite di-tap',
    },
    {
      type: 'event_when_collide',
      message0: '🤝 %1 %2 %3 %4',
      args0: [
        { type: 'field_label_serializable', name: 'TITLE', text: 'saat Tumbukan' },
        { type: 'field_dropdown', name: 'SPRITE_A', options: SPRITE_OPTIONS },
        { type: 'field_label_serializable', name: 'WITH', text: 'dengan' },
        { type: 'field_dropdown', name: 'SPRITE_B', options: SPRITE_OPTIONS },
      ],
      message1: '%1',
      args1: [{ type: 'input_statement', name: 'DO' }],
      previousStatement: null,
      nextStatement: null,
      colour: 30,
      tooltip: 'Jalankan saat dua sprite bertumbukan',
    },
    {
      type: 'event_when_key',
      message0: '⌨️ %1 %2',
      args0: [
        { type: 'field_label_serializable', name: 'TITLE', text: 'saat Tekan' },
        {
          type: 'field_dropdown',
          name: 'KEY',
          options: [
            ['⬆️', 'ArrowUp'],
            ['⬇️', 'ArrowDown'],
            ['⬅️', 'ArrowLeft'],
            ['➡️', 'ArrowRight'],
            ['Space', 'Space'],
          ],
        },
      ],
      message1: '%1',
      args1: [{ type: 'input_statement', name: 'DO' }],
      previousStatement: null,
      nextStatement: null,
      colour: 30,
      tooltip: 'Jalankan saat tombol keyboard ditekan',
    },
    {
      type: 'event_every_n_seconds',
      message0: '🔁 %1 %2 %3',
      args0: [
        { type: 'field_label_serializable', name: 'TITLE', text: 'setiap' },
        { type: 'field_number', name: 'SECONDS', value: 1, min: 0.1, max: 60, precision: 0.1 },
        { type: 'field_label_serializable', name: 'UNIT', text: 'detik' },
      ],
      message1: '%1',
      args1: [{ type: 'input_statement', name: 'DO' }],
      previousStatement: null,
      nextStatement: null,
      colour: 30,
      tooltip: 'Jalankan setiap N detik',
    },
  ])
}
